export function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/ç/g, 'c')
        .replace(/ğ/g, 'g')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ş/g, 's')
        .replace(/ü/g, 'u')
        .replace(/[^a-z0-9\s-]/g, '') // Harf, sayı, boşluk ve tire dışındakileri kaldır
        .replace(/\s+/g, '-') // Boşlukları tire yap
        .replace(/-+/g, '-') // Birden fazla tire varsa teke indir
        .replace(/^-+|-+$/g, ''); // Baştaki ve sondaki tireleri sil
}
